import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ResearchRoomsList } from "../rooms";
import "./PersistentRoomsLayout.css";

/**
 * PersistentRoomsLayout - Twitter/Reddit Style Navigation
 * 
 * This layout ensures the labs list NEVER unmounts when navigating to lab details/preview.
 * 
 * Architecture:
 * - ResearchRoomsList is ALWAYS rendered at full size
 * - When viewing lab detail/preview, list is hidden via visibility:hidden
 * - Detail pages render on TOP via Outlet
 * - Scroll position is preserved because list dimensions don't change
 * 
 * Routes covered:
 * - /labs           → List visible (Discover)
 * - /labs/my-labs   → List visible (My Labs view)
 * - /labs/:id       → List hidden, RoomDetail shown
 * - /labs/:id/preview → List hidden, RoomPreviewPage shown
 * - /labs/:id/:tab  → List hidden, RoomDetail with tab shown
 */
const PersistentRoomsLayout = () => {
  const location = useLocation();
  
  // Check if we're viewing a lab detail or preview page
  // Matches: /labs/{24-char-mongo-id} and /labs/{id}/preview and /labs/{id}/tab
  // Does NOT match: /labs, /labs/, /labs/my-labs
  const isDetailOrPreviewOpen = /^\/labs\/[a-f0-9]{24}(\/.*)?$/.test(location.pathname);

  return (
    <div className="persistent-rooms-layout">
      {/* Detail/Preview renders FIRST (on top via z-index) */}
      {isDetailOrPreviewOpen && (
        <div className="persistent-rooms-layout__detail">
          <Outlet />
        </div>
      )}
      
      {/* Rooms List Container - ALWAYS MOUNTED at full size */}
      {/* visibility:hidden when detail/preview is open, but dimensions preserved */}
      <div
        className={`persistent-rooms-layout__list ${
          isDetailOrPreviewOpen ? "persistent-rooms-layout__list--hidden" : ""
        }`}
        aria-hidden={isDetailOrPreviewOpen}
      >
        <ResearchRoomsList />
      </div>
    </div>
  );
};

export default PersistentRoomsLayout;
